// import React, { useState, useRef } from "react";
// import PropTypes, { func } from "prop-types";
// import Grid from "@mui/material/Grid";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import FormControl from "@mui/material/FormControl";
// import Title from "./Title";
// import useStyles from "./landingStyle-jss";
// import Services from "../../Services/Services";
// import Swal from "sweetalert2";
// import ValidationUtil from "../../containers/Validation/ValidationUtil";
// import "./Landing.css";
// import ContactDetails from "../../containers/LandingPage/ContactDetails";
// import ReCAPTCHA from "react-google-recaptcha";
// import CryptoJS from "crypto-js";

// function Contact(props) {
//   const formRef = useRef(null);
//   const recaptchaRef = useRef(null);
//   const { slideMode } = props;
//   const { classes, cx } = useStyles();

//   const initialState = {
//     fields: {},
//     errors: {},
//   };
//   // const [name, setName] = useState("");
//   // const [email, setEmail] = useState("");
//   // const [message, setMessage] = useState("");
//   const [getFeedbackDetails, setFeedbackDetails] = useState(initialState);
//   const [recaptchaToken, setRecaptchaToken] = useState(null);
//   const [capError, setCapError] = useState("");

//   const reCpathcaster = "6Ld-fVYqAAAAAG81885CsshLm-CX3StbNDXAGcyE";

//   const handleChange = (e) => {
//     let fields = getFeedbackDetails.fields;
//     fields[e.target.name] = e.target.value;
//     setFeedbackDetails({ ...getFeedbackDetails, fields });
//   };

//   const handleNameChange = () => {
//     let fields = getFeedbackDetails.fields;
//     let errors = getFeedbackDetails.errors;
//     if (!ValidationUtil.isCharacter(fields["username"])) {
//       errors["username"] = "*Only alphabatic characters are allowed ";
//     } else {
//       delete errors["username"];
//     }

//     setFeedbackDetails({ ...getFeedbackDetails, errors });
//   };
//   const handleEmailChange = () => {
//     let fields = getFeedbackDetails.fields;
//     let errors = getFeedbackDetails.errors;
//     if (!ValidationUtil.isEmail(fields["email"])) {
//       errors["email"] = "*Only Valid Email ID are Allowed  ";
//     } else {
//       delete errors["email"];
//     }

//     setFeedbackDetails({ ...getFeedbackDetails, errors });
//   };
//   const handleTextareaChange = () => {
//     let fields = getFeedbackDetails.fields;
//     let errors = getFeedbackDetails.errors;
//     if (!ValidationUtil.validDescription(fields["feedback"])) {
//       errors["feedback"] = "*Only Valid Characters are allowed  ";
//     } else {
//       delete errors["feedback"];
//     }

//     setFeedbackDetails({ ...getFeedbackDetails, errors });
//   };
//   const validate = () => {
//     let fields = getFeedbackDetails.fields;
//     let errors = {};
//     let formIsValid = true;

//     if (!ValidationUtil.isCharacter(fields["username"])) {
//       formIsValid = false;
//       errors["username"] = "*Only alphabatic characters are allowed";
//     } else if (!ValidationUtil.isEmail(fields["email"])) {
//       formIsValid = false;
//       errors["email"] = "*Only Valid Email ID are Allowed ";
//     } else if (!ValidationUtil.validDescription(fields["feedback"])) {
//       formIsValid = false;
//       errors["feedback"] = "*Only Valid Characters are allowed ";
//     }

//     setFeedbackDetails({ ...getFeedbackDetails, errors });

//     return formIsValid;
//   };

//   const handleCaptchaChange = (captchaToken) => {
//     // console.log("Captcha Token", captchaToken);

//     setCapError("");
//     setRecaptchaToken(captchaToken);

//     // if (captchaToken) {
//     //   const encryptCaptcha = Crypto.encrypt(
//     //     process.env.CAPTCHA_SECRET_KEY,
//     //     process.env.ENCRYPTED_CAPTCHA_SECRET_KEY
//     //   ).toString();

//     //   setRecaptchaToken(encryptCaptcha);

//     //   console.log("Encrypted captcha token", encryptCaptcha);
//     // } else {
//     //   console.error("Captcha token is missing");
//     // }
//   };

//   function submitHandler(e) {
//     e.preventDefault();
//     // if (!recaptchaToken) {
//     //   setCapError("*Please validate the reCAPTCHA");
//     //   return;
//     // }
//     if (validate()) {
//       const { username, email, feedback } = getFeedbackDetails.fields;
//       const bodyjson = {
//         username,
//         email,
//         feedback,
//         // captcha_token: recaptchaToken,
//       };
//       // console.log("feedback", bodyjson);

//       Services.userFeedback(bodyjson)
//         .then(async (response) => {
//           // console.log("feedback response", response);
//           if (response.status === 200) {
//             Swal.fire({
//               title: "Success!",
//               text: response.data.message,
//               icon: "success",
//             }).then(() => {
//               if (recaptchaRef.current) {
//                 recaptchaRef.current.reset();
//               }
//             });
//           } else {
//             Swal.fire({
//               title: "Error",
//               text: "Feedback Not sent!",
//               icon: "error",
//             }).then(() => {
//               if (recaptchaRef.current) {
//                 recaptchaRef.current.reset();
//               }
//             });
//           }
//         })
//         .catch((error) => {
//           // console.log("feedback error", error);
//           Swal.fire({
//             title: "Error",
//             text: `${error.response.data.message}`,
//             icon: "error",
//           });
//         });
//       formRef.current.reset();
//     }
//   }

//   return (
//     <div className={cx(classes.contact, !slideMode && classes.withBg)}>
//       <div className={classes.container}>
//         <div className={classes.contactBubble}>
//           <Grid container spacing={3}>
//             <Grid item lg={4} xs={12}>
//               <div className={classes.cardContactDetails}>
//                 <ContactDetails />
//               </div>
//             </Grid>
//             <Grid item lg={8} xs={12}>
//               <div>
//                 <Title title="Your Feedback" align="left" nomargin />
//                 <Typography component="p" className={classes.contactText}>
//                   We value your feedback and appreciate your input. Your
//                   feedback is important to us as it helps us improve and provide
//                   a better experience for our users. We welcome any suggestions,
//                   comments, or concerns you may have regarding our content or
//                   services.
//                 </Typography>
//                 <form ref={formRef} onSubmit={submitHandler}>
//                   <Grid container spacing={3}>
//                     <Grid item lg={12} xs={12}>
//                       <FormControl
//                         variant="standard"
//                         className={classes.formControl}
//                       >
//                         <TextField
//                           variant="standard"
//                           fullWidth
//                           label="Who are You?"
//                           className={classes.textField}
//                           required
//                           name="username"
//                           onChange={handleChange}
//                           margin="normal"
//                           onBlur={handleNameChange}
//                         />
//                         <span className="errorMsg text-left text-danger">
//                           {getFeedbackDetails.errors["username"]}
//                         </span>
//                       </FormControl>
//                       <FormControl
//                         variant="standard"
//                         className={classes.formControl}
//                       >
//                         <TextField
//                           variant="standard"
//                           fullWidth
//                           id="standard-email"
//                           label="You'r email?"
//                           className={classes.textField}
//                           name="email"
//                           required
//                           onChange={handleChange}
//                           margin="normal"
//                           onBlur={handleEmailChange}
//                         />
//                       </FormControl>
//                       <span className="errorMsg text-left text-danger">
//                         {getFeedbackDetails.errors["email"]}
//                       </span>
//                       {/* <Grid item lg={12} xs={12}> */}
//                       <FormControl
//                         variant="standard"
//                         className={classes.formControl}
//                       >
//                         <TextField
//                           variant="standard"
//                           fullWidth
//                           id="standard-multiline-flexible"
//                           label="Messages"
//                           multiline
//                           rows="4"
//                           name="feedback"
//                           onChange={handleChange}
//                           className={classes.textField}
//                           margin="normal"
//                           onBlur={handleTextareaChange}
//                         />
//                       </FormControl>
//                       <span className="errorMsg text-left text-danger">
//                         {getFeedbackDetails.errors["feedback"]}
//                       </span>
//                       {/* <div>
//                         <ReCAPTCHA
//                           ref={recaptchaRef}
//                           sitekey={reCpathcaster}
//                           onChange={handleCaptchaChange}
//                         />
//                         <span className="errorMsg text-left text-danger">
//                           {capError && capError}
//                         </span>
//                       </div> */}
//                       <div className={classes.btnArea}>
//                         <Button
//                           variant="contained"
//                           size="large"
//                           className={classes.button}
//                           color="secondary"
//                           type="submit"
//                         >
//                           Send
//                         </Button>
//                       </div>
//                       {/* </Grid> */}
//                     </Grid>
//                   </Grid>
//                 </form>
//               </div>
//             </Grid>
//           </Grid>
//         </div>
//       </div>
//     </div>
//   );
// }

// Contact.propTypes = {
//   slideMode: PropTypes.bool,
// };

// Contact.defaultProps = {
//   slideMode: false,
// };

// export default Contact;

import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography"; // Import Typography for styling
import Title from "./Title";
import useStyles from "./landingStyle-jss";
import ContactDetails from "../../containers/LandingPage/ContactDetails";

function Contact(props) {
  const { slideMode } = props;
  const { classes, cx } = useStyles();

  const contactData = [
    {
      title: "ISEA Academic Activities",
      email: "isea[at]cdac[dot]in",
    },
    {
      title: "CISOs Training & Certification",
      email: "isea-ciso[at]cdac[dot]in",
    },
    {
      title: "ISEA Awareness Activities",
      email: "isea[at]cdac[dot]in",
    },
    {
      title: "ISEA Virtual Platform",
      email: "support-ivp[at]cdac[dot]in",
    },
  ];

  return (
    <div className={cx(classes.contact, !slideMode && classes.withBg)}>
      <div className={classes.container}>
        <div className={classes.contactBubble}>
          <Grid container spacing={3}>
            <Grid item lg={6} xs={12}>
              <div className={classes.cardContactDetails}>
                <ContactDetails />
              </div>
            </Grid>
            <Grid item lg={6} xs={12}>
              <div>
                <Title title="Query related to" align="left" nomargin />
                {contactData.map((item, index) => (
                  <div key={index} className={classes.contactItem}>
                    <Typography variant="h5" className={classes.contactTitle}>
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      className={classes.contactEmail}
                    >
                      {item.email}
                    </Typography>
                  </div>
                ))}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}

Contact.propTypes = {
  slideMode: PropTypes.bool,
};

Contact.defaultProps = {
  slideMode: false,
};

export default Contact;
